import {createMuiTheme} from '@material-ui/core/styles';
import theme from './theme';

// Styles that should be applied for DESKTOP only, should be placed here

const appTheme = {
  spacing: () => {},
  ...theme,
  overrides: {
    ...theme.overrides
  }
};


export default createMuiTheme(appTheme);
